import SEOPageTemplate from '../components/SEOPageTemplate';

const ChauffeurBoston = () => (
  <SEOPageTemplate
    city="Boston"
    state="MA"
    route="/chauffeur-boston-ma"
    imageSrc="/boston-limo.jpg"
    introduction="In Boston's historic streets, where cobblestone meets corporate, TiLimousine delivers a transportation experience that matches the city's sophistication. Our chauffeurs are more than drivers — they're your local experts, navigating the intricate network of one-way streets, construction zones, and peak-hour traffic with precision. From Logan Airport to the Financial District, from Back Bay to the Seaport, we ensure your journey through Boston is as seamless as it is luxurious."
    testimonial={{
      quote: "As a biotech executive, I need reliable transportation for investor meetings across Boston. TiLimousine's chauffeurs know every biotech hub in the city, from Kendall Square to the Seaport. Their attention to detail and punctuality have been invaluable.",
      author: "Dr. Michael R.",
      role: "VP of Business Development, Boston Biotech"
    }}
    fboLink={{
      url: "https://signatureflight.com/locations/boston",
      name: "Signature Aviation – Boston Logan"
    }}
    services={[
      'Luxury chauffeur service for airport transfers and FBO pickup',
      'Executive car service and black car service for business travel',
      'Hourly chauffeur hire and as-directed black car service',
      'Private driver service for events, weddings, and VIPs',
      'Long-distance city-to-city rides: Boston ⇄ NYC, Boston ⇄ Providence',
      'Professional chauffeur company for meetings and corporate events',
      'Livery service and luxury livery transportation',
      'Town car service and car and driver rental',
      'Book a chauffeur in Boston',
      'Best chauffeur in Massachusetts',
      'Chauffeured transportation for VIPs',
      'Luxury car with driver',
      'Business travel car service',
      'Limo vs black car service Boston',
      'Best executive car service in Boston',
      'FBO pickup with luxury car',
      'Chauffeur for meetings and corporate events'
    ]}
    airports={[
      'Logan International Airport (BOS)',
      'Hanscom Field (BED)',
      'Signature Flight Support',
      'Atlantic Aviation',
      'Teterboro Airport (TEB)',
      'JFK',
      'LGA',
      'Providence T.F. Green International Airport (PVD)'
    ]}
    neighborhoods={[
      'Back Bay',
      'Financial District',
      'Seaport District',
      'Beacon Hill',
      'South End',
      'North End',
      'Cambridge',
      'Kendall Square',
      'Charlestown',
      'Waterfront',
      'Downtown Boston',
      'Greater Boston Area'
    ]}
  />
);

export default ChauffeurBoston; 